import React from "react";
import { Helmet } from "react-helmet-async";
import { useStore } from "../context/StoreContext";
import "./Legal.css";

export default function Terms() {
  const { navigate } = useStore();

  return (
    <div className="legal-page">
      <Helmet>
        <title>Terms & Conditions — City Shopping Center & Dulha House</title>
        <meta name="description" content="Terms & Conditions for shopping with City Shopping Center & Dulha House, Daska, Pakistan." />
        <link rel="canonical" href="https://cityshopingcenter.com/terms" />
      </Helmet>

      <div className="page-header" data-echo="TERMS">
        <h1>TERMS &amp; CONDITIONS</h1>
        <p>Last updated: 12 July 2026</p>
      </div>

      <div className="legal-wrap">
        <p>
          Welcome to cityshopingcenter.com, operated by City Shopping Center &amp; Dulha House
          ("we", "our", "us"). By accessing or using this website (the "Site"), you agree to these
          Terms &amp; Conditions. If you do not agree, please do not use the Site.
        </p>

        <h2>1. About Our Store</h2>
        <p>We sell premium artificial jewelry, including American Diamond (AD), zircon, and fancy
        jewelry. Our physical store is located at Shop# 23, Touseef Market, Daska, Pakistan, and has
        served customers since 2001.</p>

        <h2>2. Orders &amp; WhatsApp Checkout</h2>
        <p>Orders placed through this Site are completed via WhatsApp. When you check out, an order
        summary is prepared and sent to us through WhatsApp for confirmation. An order is only
        considered confirmed once we reply to you on WhatsApp and agree on the items, price, and
        delivery details. We reserve the right to decline or cancel any order — for example, if an
        item is out of stock or a listing contained an obvious pricing error.</p>

        <h2>3. Prices &amp; Payment</h2>
        <p>All prices on the Site are listed in Pakistani Rupees (PKR / Rs.) and may change at any
        time without notice. Payment methods, delivery charges, and delivery timelines are agreed
        with you directly on WhatsApp at the time of order confirmation.</p>

        <h2>4. Product Descriptions &amp; Images</h2>
        <p>We make every effort to display our products accurately. However, jewelry colors and
        sparkle may appear slightly different depending on your screen, lighting, and photography.
        Minor variations between product photos and the delivered item do not constitute a defect.
        All jewelry sold on this Site is artificial / fashion jewelry unless explicitly stated
        otherwise.</p>

        <h2>5. Returns &amp; Exchanges</h2>
        <p>If you receive a damaged or incorrect item, contact us on WhatsApp within 48 hours of
        delivery with clear photos, and we will arrange a replacement or exchange. For hygiene
        reasons, earrings and worn items cannot be returned unless faulty. Exchange and return
        arrangements, including any courier costs, are confirmed case by case on WhatsApp.</p>

        <h2>6. Your Account</h2>
        <p>You are responsible for keeping your account credentials confidential and for all
        activity under your account. Please provide accurate information when creating an account.
        We may suspend or delete accounts that are used fraudulently or abusively.</p>

        <h2>7. Acceptable Use</h2>
        <p>You agree not to misuse the Site — including attempting to gain unauthorized access,
        interfering with the Site's operation, scraping content in bulk, or using the Site for any
        unlawful purpose.</p>

        <h2>8. Intellectual Property</h2>
        <p>All content on this Site — including text, product photographs, logos, articles, and
        design — belongs to City Shopping Center &amp; Dulha House and may not be copied,
        reproduced, or used commercially without our written permission.</p>

        <h2>9. Advertising</h2>
        <p>This Site may display third-party advertisements (for example, through Google AdSense).
        We are not responsible for the content of third-party ads or the websites they link to. See
        our{" "}
        <button className="legal-inline-link" onClick={() => navigate("privacy-policy")}>
          Privacy Policy
        </button>{" "}
        for details about advertising cookies.</p>

        <h2>10. Limitation of Liability</h2>
        <p>The Site is provided "as is". To the maximum extent permitted by law, we are not liable
        for indirect or consequential losses arising from your use of the Site. Our total liability
        for any claim related to an order is limited to the amount you paid for that order.</p>

        <h2>11. Changes to These Terms</h2>
        <p>We may update these Terms from time to time. Updates will be posted on this page with a
        revised "Last updated" date. Continued use of the Site after changes means you accept the
        updated Terms.</p>

        <h2>12. Governing Law &amp; Contact</h2>
        <p>These Terms are governed by the laws of Pakistan. For any questions, contact us at
        cityshoppingcenter.pk@gmail.com or via WhatsApp from our{" "}
        <button className="legal-inline-link" onClick={() => navigate("contact")}>Contact page</button>.</p>
      </div>
    </div>
  );
}
